import { Editor, Text } from 'slate';
import { ReactEditor } from 'slate-react';

export const COUNT_ITEM = 'count_item';

export type EditorType = Editor & ReactEditor;

export const isMarkActive = (editor: EditorType, type: any) => {
  try {
    const marks = Editor.marks(editor);
    return marks ? marks[type] === true : false;
  } catch (e) {
    return false;
  }
};

export const toggleMark = (editor: EditorType, type: string, value: any = true) => {
  const isActive = isMarkActive(editor, type);

  if (isActive) {
    Editor.removeMark(editor, type);
  } else {
    Editor.addMark(editor, type, value);
  }
};

export const getNodeOffset = (editor: EditorType, range: any) => {
  const [, from] = Editor.first(editor, range);
  const [, to] = Editor.first(editor, []);
  const span: any = [from, to];
  const nodeEntries = Editor.nodes(editor, {
    reverse: true,
    mode: 'all',
    at: span,
    match: (item: any) => {
      return Boolean(item.text);
    },
    voids: true,
  });
  const result = Array.from(nodeEntries);
  result.shift();
  return result.reduce((sum, [item]: any) => sum + item.text.length, 0);
};

export const getCountNode = (editor: EditorType) => {
  const [, from] = Editor.last(editor, []);
  const [, to] = Editor.first(editor, []);
  const span: any = [from, to];
  const nodeEntries = Editor.nodes(editor, {
    reverse: true,
    mode: 'all',
    at: span,
    match: (item: any) => {
      return item.type === COUNT_ITEM;
    },
    voids: true,
  });
  const result = Array.from(nodeEntries);
  result.shift();
  return result;
};

export const getAllEditorNodes = (editor: EditorType) => {
  if (!editor) {
    return [];
  }
  const nodeEntries = Editor.nodes(editor, {
    mode: 'all',
    at: [],
    match: (item: any) => {
      return Text.isText(item);
    },
    voids: true,
  });
  return Array.from(nodeEntries)
    .map(([node]) => {
      return node;
    })
    .filter((node: any) => node?.text?.trim()?.length > 0);
};

const SpecialType = ['IMAGE', 'VIDEO', 'FILE', 'AUDIO', 'HYPERLINK'];
export const isNotEmptyEditor = (editor: EditorType) => {
  if (!editor) {
    return false;
  }
  const nodeEntries = Editor.nodes(editor, {
    mode: 'all',
    at: [],
    match: (item: any) => {
      return Text.isText(item);
    },
    voids: true,
  });
  const specialNodeEntries = Editor.nodes(editor, {
    mode: 'all',
    at: [],
    match: (item: any) => {
      return SpecialType.includes(item.type);
    },
    voids: true,
  });
  return (
    Array.from(nodeEntries)
      .map(([node]) => {
        return node;
      })
      .filter((node: any) => node?.text?.trim()?.length > 0).length > 0 ||
    Array.from(specialNodeEntries)?.length > 0
  );
};
